export const messages = {
  affectedProducts: {
    id: 'admin/promotions.form.review.footer.affected-products',
  },
}
